import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { apiClient } from "../../../zodios/client";
import { successToast, errorToast } from "../../../utils/toasts";

export const useDeleteShopifyConnection = () => {
  const { t } = useTranslation(["onboarding"]);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => await apiClient.deleteShopifyConnection(undefined),
    onSuccess: () => {
      successToast({
        message: t(($) => $.onboarding.shopifyToasts["Shopify store disconnected."]),
      });
      void queryClient.invalidateQueries({ queryKey: ["shopify-connection-status"] });
    },
    onError: (error: unknown) => {
      errorToast({
        message: t(($) => $.onboarding.shopifyToasts["Failed to disconnect Shopify store."]),
        error,
      });
    },
  });
};
